import { render, staticRenderFns } from "./Enclosed.vue?vue&type=template&id=043067de&"
import script from "./Enclosed.vue?vue&type=script&lang=js&"
export * from "./Enclosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports